<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">

        <div class="card border-0 shadow-sm overflow-hidden w-100 mb-2">
          <div class="card-body text-white p-4" style="background: linear-gradient(135deg, #007bff, #6610f2);">
            <div class="row align-items-center">
              <div class="col-md-8 mb-3 mb-md-0">
                <h5 class="card-title font-weight-bold mb-2 text-white">¡Renueva tu licencia ahora!</h5>
                <p class="card-text small mb-0">
                  Extiende tu licencia por otro mes y sigue disfrutando de todos los beneficios que ofrecemos.
                </p>
              </div>
              <div class="col-md-4 text-md-end">
                <button 
                  class="btn btn-light btn-sm text-primary font-weight-bold px-4 rounded-pill"
                  @click="payment"
                >
                  Renovar ahora
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header pb-0">
            <h6>Historial de pagos</h6>

          </div>

         

          
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Pago id</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Valor</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Fecha de pago</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Fecha de vigencia</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.payment_id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ parseFloat(value?.amount ).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatDate(value?.created_at) }} 
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatDate(value?.coverage_month) }} 
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span 
                        class="badge badge-sm"
                        :class="{
                          'bg-gradient-warning': value.status === 'pending',  // Pendiente
                          'bg-gradient-danger': value.status === 'rejected',  // Producción
                          'bg-gradient-success': value.status === 'paid',  // Terminado
                        }"
                      >
                        {{
                          value.status === 'pending' ? 'Pendiente' :
                          value.status === 'rejected' ? 'Rechazado' :
                          value.status === 'paid' ? 'Pagado': 'Anulado'
                        }}
                      </span>
                    </td>

                    
                  </tr>
                
                  <tr v-if="data.length === 0">
                    <td colspan="5" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

            </div>

          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import Swal from 'sweetalert2';

export default {
  name: 'ProjectsTable',
  data() {
    return {
      data:[]
    };
  },
  computed: {
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const dateOnly = String(dateStr).split('T')[0];
      const d = new Date(dateOnly + 'T00:00:00');
      if (isNaN(d.getTime())) return '-';
      return d.toLocaleDateString('es-ES');
    },
    async fetchData() {
      const response = await this.$store.dispatch('payments/getAll'); 
      this.data = response?.data?.data??[];
    },
    async payment() {
      const response = await this.$store.dispatch('payments/create'); 
      const data = response.data;
      if (data.formUrl) {
        window.location.href = data.formUrl;
      }else{
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al generar pago',
        });
      }

    },
  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}
</style>